// Mobile carousel with Slick Carousel
document.addEventListener('DOMContentLoaded', function() {
  let slickInstance = null;
  
  function initMobileSlick() {
    const mobileCarousels = document.querySelectorAll('.carousel--mobile > .group-block-content');
    
    if (window.innerWidth <= 749) {
      // Initialize Slick for mobile
      console.log("FOUND CAROUSEL", mobileCarousels);
      mobileCarousels.forEach(function(carousel) {
        if (!carousel.classList.contains('slick-initialized')) {
          // Wrap slides for Slick if needed
          const slides = carousel.children;
          if (slides.length > 0) {
            $(carousel).slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              dots: true,
              arrows: false,
              adaptiveHeight: true,
              mobileFirst: true,
              responsive: [
                {
                  breakpoint: 749,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: true
                  }
                }
              ]
            });
          }
        }
      });
    } else {
      // Destroy Slick on desktop
      mobileCarousels.forEach(function(carousel) {
        if (carousel.classList.contains('slick-initialized')) {
          $(carousel).slick('unslick');
        }
      });
    }
  }
  
  // Initialize on load
  initMobileSlick();
  
  // Reinitialize on resize
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initMobileSlick, 250);
  });
});
